'use es6';

import { useEffect } from 'react';
import { connect } from 'react-redux';
import { DragSource } from 'react-dnd-compat';
import { getEmptyImage } from 'react-dnd-ipeui-backend';
import { makeGetCellOrRowParentId, getLayoutSectionTreeById } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { dragTypes } from 'InpageEditorUI/lib/layoutSection/constants';
import { draggingStartedAndDeselectExisting as draggingStartedAndDeselectExistingAction, draggingStoppedAndReselectIfNeeded as draggingStoppedAndReselectIfNeededAction } from 'InpageEditorUI/redux/actions/layoutSectionDndActions';
import { buildActionsForRow, BaseResponsiveRowToolbar } from './BaseResponsiveRowToolbar';
import { DEFAULT_RESPONSIVE_SIZE } from 'layout-dnd-components/DndToolbar/constants';
import { getIsInDefaultBreakpointMode } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { getIsInDeveloperMode } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { getSelectedItemId } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import { useToggleNodeVisibilityOnThisBreakpoint, getRowById } from 'ContentEditorUI/components/sidebar/contentTree/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const dragSource = {
  beginDrag(props) {
    const {
      id,
      parentId,
      draggingStartedAndDeselectExisting,
      layoutSectionId
    } = props;
    const dragItem = {
      dragId: id,
      dragParentId: parentId,
      isColumn: false,
      isRow: true,
      isTopMostRow: false,
      originLayoutSectionId: layoutSectionId
    };
    draggingStartedAndDeselectExisting(dragItem);
    return dragItem;
  },
  canDrag(props) {
    return props.isInDefaultBreakpointMode;
  },
  endDrag(props, monitor) {
    const {
      draggingStoppedAndReselectIfNeeded
    } = props;
    draggingStoppedAndReselectIfNeeded(monitor.getItem(), monitor.didDrop());
  }
};
function dragCollect(monitor) {
  return {
    isDragging: monitor.isDragging()
  };
}
const mapStateToProps = () => {
  const getCellOrRowParentId = makeGetCellOrRowParentId();
  return (state, ownProps) => {
    if (ownProps.id) {
      return {
        parentId: getCellOrRowParentId(state, {
          layoutSectionId: ownProps.layoutSectionId,
          id: ownProps.id
        }),
        isInDefaultBreakpointMode: getIsInDefaultBreakpointMode(state),
        isInDeveloperMode: getIsInDeveloperMode(state),
        selectedItemId: getSelectedItemId(state),
        layoutSectionTree: getLayoutSectionTreeById(state, {
          layoutSectionId: ownProps.layoutSectionId
        })
      };
    }
    return {};
  };
};
const mapDispatchToProps = {
  draggingStartedAndDeselectExisting: draggingStartedAndDeselectExistingAction,
  draggingStoppedAndReselectIfNeeded: draggingStoppedAndReselectIfNeededAction
};

/**
 * @param {string} props.id (optional)
 * @param {string} props.layoutSectionId (optional)
 * @param {boolean} props.active (required)
 * @param {number} props.top (required)
 * @param {number} props.left (required)
 * @param {Function} props.onHandleMouseDown (optional)
 * @param {Function} props.onDropdownOpenChange (optional)
 * @param {string} props.responsiveSize (optional)
 * @param {Function} props.draggingStartedAndDeselectExisting (required)
 * @param {Function} props.draggingStoppedAndReselectIfNeeded (required)
 * @param {Function} props.connectDragPreview (required)
 * @param {Function} props.connectDragSource (required)
 * @param {Function} props.dispatch (required)
 * @param {Object} props.bus (required)
 * @param {boolean} props.isInDefaultBreakpointMode (optional)
 * @param {boolean} props.isInDeveloperMode (optional)
 * @param {string} props.selectedItemId (optional)
 * @param {Object} props.layoutSectionTree (optional)
 */
const ResponsiveRowToolbarComponent = ({
  id,
  layoutSectionId,
  active,
  top,
  left,
  onHandleMouseDown,
  onDropdownOpenChange,
  responsiveSize = DEFAULT_RESPONSIVE_SIZE,
  connectDragPreview,
  connectDragSource,
  dispatch,
  bus,
  isInDefaultBreakpointMode,
  isInDeveloperMode,
  selectedItemId,
  layoutSectionTree
}) => {
  const treeRow = layoutSectionTree ? getRowById(layoutSectionTree, id) : null;
  const toggleNodeVisibilityOnThisBreakpoint = useToggleNodeVisibilityOnThisBreakpoint(treeRow);
  const canToggleRowVisibility = treeRow && treeRow.getColumns().length > 1;
  useEffect(() => {
    connectDragPreview(getEmptyImage(), {
      captureDraggingState: true
    });
  }, [connectDragPreview]);
  return /*#__PURE__*/_jsx(BaseResponsiveRowToolbar, {
    active: active,
    actions: buildActionsForRow({
      rowName: id,
      layoutSectionId,
      isInDefaultBreakpointMode,
      dispatch,
      bus,
      isInDeveloperMode,
      toggleNodeVisibilityOnThisBreakpoint,
      canToggleRowVisibility
    }),
    insetBlockStart: `${top}px`,
    insetInlineStart: `${left}px`,
    responsiveSize: responsiveSize,
    onHandleMouseDown: onHandleMouseDown,
    onDropdownOpenChange: onDropdownOpenChange,
    connectDragSource: connectDragSource,
    isSelectedItem: id === selectedItemId
  });
};
export default connect(mapStateToProps, mapDispatchToProps)(DragSource(dragTypes.EXISTING_ITEM, dragSource, dragCollect)(ResponsiveRowToolbarComponent));